<script>
  import Button from "./Button.svelte";

  export let style='border: none; background-color: transparent;';
  export let title;
  export let width = 200;
  export let left = 0;
  export let backgroundColor = 'var(--background)';

  let showContent = false;
</script>

<div class="dropdown" on:mouseleave={() => {showContent = false}}>
  <Button style={style} on:click={() => {showContent = !showContent}}>{title}</Button>
  {#if showContent}
    <div class="dropdown-content" style='width: {width}px; left: {left}px; background-color: {backgroundColor}'>
      <slot/>
    </div>
  {/if}
</div>

<style>
  .dropdown {
    display: inline-block;
    position: relative;
  }
  .dropdown-content {
    display: flex;
    position: absolute;
    overflow: auto;
    /* box-shadow: 0px 3px 3px 2px rgba(0,0,0,0.1); */
    flex-direction: column;
    align-items: stretch;
    z-index: 99;
  }

</style>